import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { type FeatureToggle } from './featureToggles'

export const seoSettingsAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.SeoSettings],
}
